/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Hilldun_Approval_Not_RecordableInputs */

const en_error_hilldun_approval_not_recordable = /** @type {(inputs: Error_Hilldun_Approval_Not_RecordableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The approval of Hilldun cannot be recorded on this order.`)
};

/**
* | output |
* | --- |
* | "The approval of Hilldun cannot be recorded on this order." |
*
* @param {Error_Hilldun_Approval_Not_RecordableInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_hilldun_approval_not_recordable = /** @type {((inputs?: Error_Hilldun_Approval_Not_RecordableInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Hilldun_Approval_Not_RecordableInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_hilldun_approval_not_recordable(inputs)
});